"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactEasyCrop = _interopRequireDefault(require("react-easy-crop"));

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

var _reactReduxI18n = require("react-redux-i18n");

var _UploadDropzone = _interopRequireDefault(require("../upload/UploadDropzone"));

var _imageUtils = require("./imageUtils");

var _jsxRuntime = require("react/jsx-runtime");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// eslint-disable-next-line spaced-comment
var isIE =
/*@cc_on!@*/
false || Boolean(document.documentMode);
var cropMinZoom = isIE ? 1 : 0.05;
var CONTAINER_HEIGHT = 350;

var ImageCropper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ImageCropper, _Component);

  var _super = _createSuper(ImageCropper);

  function ImageCropper(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, ImageCropper);
    _this = _super.call(this, props, context);
    _this.state = {
      fileName: '',
      fileDataUrl: '',
      fileTypeError: null,
      hasImage: false,
      cropPosition: {
        x: 0,
        y: 0
      },
      cropZoom: 1,
      croppedAreaPixels: null
    };
    _this.handleDropRejected = _this.handleDropRejected.bind((0, _assertThisInitialized2.default)(_this));
    _this.setHasImage = _this.setHasImage.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDrop = _this.handleDrop.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetchImageFunction = _this.fetchImageFunction.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ImageCropper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.fetchImageFunction(this.fetchImageFunction);
    }
  }, {
    key: "handleDropRejected",
    value: function handleDropRejected() {
      var fileTypeError = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "error",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "uploadImage.errorTypeMessage"
        })
      });
      this.setState({
        fileTypeError: fileTypeError
      });
    }
  }, {
    key: "setHasImage",
    value: function setHasImage(hasImage) {
      this.setState({
        hasImage: hasImage
      });
      this.props.onHasImage(hasImage);
    }
  }, {
    key: "handleDrop",
    value: function () {
      var _handleDrop = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(acceptedFiles, rejectedFiles) {
        var fileDataUrl, fileName;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  fileTypeError: null
                });
                this.setHasImage(false);

                if (!acceptedFiles.length) {
                  _context.next = 11;
                  break;
                }

                _context.next = 5;
                return (0, _imageUtils.readFile)(acceptedFiles[0]);

              case 5:
                fileDataUrl = _context.sent;
                fileName = acceptedFiles[0].name;
                this.setHasImage(Boolean(acceptedFiles.length && fileName && fileDataUrl));
                this.setState({
                  fileDataUrl: fileDataUrl,
                  fileName: fileName
                });
                _context.next = 12;
                break;

              case 11:
                if (rejectedFiles.length > 0) {
                  this.handleDropRejected();
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleDrop(_x, _x2) {
        return _handleDrop.apply(this, arguments);
      }

      return handleDrop;
    }()
  }, {
    key: "fetchImageFunction",
    value: function fetchImageFunction() {
      if (!this.state.hasImage) {
        // eslint-disable-next-line no-console
        console.error('Impossible to fetch image: there is no image');
        return null;
      }

      return {
        croppedAreaPixels: this.state.croppedAreaPixels,
        fileDataUrl: this.state.fileDataUrl
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadDropzone.default, {
          fileName: this.state.fileName,
          onDrop: this.handleDrop,
          onDropRejected: this.handleDropRejected,
          extensions: '.png,.jpg,.jpeg',
          errorFileMessage: this.state.fileTypeError
        }), this.state.hasImage && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "mt-3",
            style: {
              height: "".concat(CONTAINER_HEIGHT, "px"),
              position: 'relative'
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactEasyCrop.default, {
              minZoom: cropMinZoom,
              aspect: this.props.cropAspect,
              image: this.state.fileDataUrl,
              crop: this.state.cropPosition,
              zoom: this.state.cropZoom,
              restrictPosition: isIE,
              showGrid: false,
              onCropChange: function onCropChange(cropPosition) {
                return _this2.setState({
                  cropPosition: cropPosition
                });
              },
              onZoomChange: function onZoomChange(cropZoom) {
                return _this2.setState({
                  cropZoom: cropZoom
                });
              },
              onCropComplete: function onCropComplete(croppedArea, croppedAreaPixels) {
                return _this2.setState({
                  croppedAreaPixels: croppedAreaPixels
                });
              },
              onMediaLoaded: function onMediaLoaded(mediaSize) {
                var cropZoomWidth = CONTAINER_HEIGHT * _this2.props.cropAspect / mediaSize.width;
                var cropZoomHeight = CONTAINER_HEIGHT / mediaSize.height;

                _this2.setState({
                  cropZoom: cropZoomWidth < cropZoomHeight ? cropZoomWidth : cropZoomHeight
                });
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "my-4 inline-container",
            style: {
              width: '100%'
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Slider.default, {
              min: cropMinZoom,
              value: this.state.cropZoom,
              max: 3,
              step: 0.02,
              onChange: function onChange(event, cropZoom) {
                return _this2.setState({
                  cropZoom: cropZoom
                });
              }
            })
          })]
        })]
      });
    }
  }]);
  return ImageCropper;
}(_react.Component);

ImageCropper.defaultProps = {
  onHasImage: function onHasImage() {},
  cropAspect: 4 / 3
};
ImageCropper.propTypes = {
  fetchImageFunction: _propTypes.default.func.isRequired,
  onHasImage: _propTypes.default.func,
  cropAspect: _propTypes.default.number
};
var _default = ImageCropper;
exports.default = _default;
//# sourceMappingURL=ImageCropper.js.map